module.exports = __webpack_public_path__ + "media/images/landkit/photos/photo-3-fadf6fa2a7507441902923da74c888ec.jpg";